//============================================================================
// Name        : api_logs.ts
// Purpose     : Implement handheld api logs
// Created     : 2020-01-31
// Author      : Senitron Team
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================

import {InitPage} from "../index";

declare var apiMonitorPath: string;

class ApiMonitor {
    constructor() {
        // Auto populate hours from previous checked
        $("input[type=checkbox]").on("change", (e) => {
            const attrName = $(e.target).attr("name");
            const name = attrName.split("[")[1].split("]")[0];

            const lastValues = this.getLastValues();

            $(`input[name='api_monitor[${name}_start]']`).val(lastValues.startHour);
            $(`input[name='api_monitor[${name}_end]']`).val(lastValues.endHour);
        });

        $(".show-add-apimonitor").on("click", () => {
            const editDialog = $("#edit-apimonitor");
            const form       = $("form");
            const apiSelect  = $("#api");

            editDialog.modal("show");
            $("#api_monitor_id").val("");
            apiSelect.select2({dropdownParent: editDialog});

            // Set form path
            form.prop("action", apiMonitorPath);
            $("input[name='_method']").val("post");

            // Reset dialog fields
            apiSelect.val("").trigger("change");

            $("input[name='api_monitor[monday]']").prop("checked", false);
            $("input[name='api_monitor[monday_start]']").val("");
            $("input[name='api_monitor[monday_end]']").val("");

            $("input[name='api_monitor[tuesday]']").prop("checked", false);
            $("input[name='api_monitor[tuesday_start]']").val("");
            $("input[name='api_monitor[tuesday_end]']").val("");

            $("input[name='api_monitor[wednesday]']").prop("checked", false);
            $("input[name='api_monitor[wednesday_start]']").val("");
            $("input[name='api_monitor[wednesday_end]']").val("");

            $("input[name='api_monitor[thursday]']").prop("checked", false);
            $("input[name='api_monitor[thursday_start]']").val("");
            $("input[name='api_monitor[thursday_end]']").val("");

            $("input[name='api_monitor[friday]']").prop("checked", false);
            $("input[name='api_monitor[friday_start]']").val("");
            $("input[name='api_monitor[friday_end]']").val("");

            $("input[name='api_monitor[saturday]']").prop("checked", false);
            $("input[name='api_monitor[saturday_start]']").val("");
            $("input[name='api_monitor[saturday_end]']").val("");

            $("input[name='api_monitor[sunday]']").prop("checked", false);
            $("input[name='api_monitor[sunday_start]']").val("");
            $("input[name='api_monitor[sunday_end]']").val("");

            $("input[name='api_monitor[notify_emails]']").val("");

            $("input[name='api_monitor[check_hour_interval]']").val(3);

            const enabledCheck = $("input[name='api_monitor[enabled]']");
            enabledCheck.val("1");
            enabledCheck.prop("checked", "checked");
        });

        $(".show-edit-apimonitor").on("click", (e) => {
            const apiMonitor = $(e.target).data("record");

            const form       = $("form");
            const target     = $(e.target);
            const editDialog = $("#edit-apimonitor");
            const apiSelect  = $("#api");

            // Set form path
            form.prop("action", apiMonitorPath + "/" + apiMonitor.id);
            $("input[name='_method']").val("patch");

            editDialog.modal("show");
            $("#api_monitor_id").val(target.data("id"));
            apiSelect.select2({dropdownParent: editDialog});

            // Populate API monitor
            apiSelect.val(apiMonitor.api).trigger("change");

            $("input[name='api_monitor[monday]']").prop("checked", apiMonitor.monday);
            $("input[name='api_monitor[monday_start]']").val(apiMonitor.monday_start);
            $("input[name='api_monitor[monday_end]']").val(apiMonitor.monday_end);

            $("input[name='api_monitor[tuesday]']").prop("checked", apiMonitor.tuesday);
            $("input[name='api_monitor[tuesday_start]']").val(apiMonitor.tuesday_start);
            $("input[name='api_monitor[tuesday_end]']").val(apiMonitor.tuesday_end);

            $("input[name='api_monitor[wednesday]']").prop("checked", apiMonitor.wednesday);
            $("input[name='api_monitor[wednesday_start]']").val(apiMonitor.wednesday_start);
            $("input[name='api_monitor[wednesday_end]']").val(apiMonitor.wednesday_end);

            $("input[name='api_monitor[thursday]']").prop("checked", apiMonitor.thursday);
            $("input[name='api_monitor[thursday_start]']").val(apiMonitor.thursday_start);
            $("input[name='api_monitor[thursday_end]']").val(apiMonitor.thursday_end);

            $("input[name='api_monitor[friday]']").prop("checked", apiMonitor.friday);
            $("input[name='api_monitor[friday_start]']").val(apiMonitor.friday_start);
            $("input[name='api_monitor[friday_end]']").val(apiMonitor.friday_end);

            $("input[name='api_monitor[saturday]']").prop("checked", apiMonitor.saturday);
            $("input[name='api_monitor[saturday_start]']").val(apiMonitor.saturday_start);
            $("input[name='api_monitor[saturday_end]']").val(apiMonitor.saturday_end);

            $("input[name='api_monitor[sunday]']").prop("checked", apiMonitor.sunday);
            $("input[name='api_monitor[sunday_start]']").val(apiMonitor.sunday_start);
            $("input[name='api_monitor[sunday_end]']").val(apiMonitor.sunday_end);

            $("input[name='api_monitor[check_hour_interval]']").val(apiMonitor.check_hour_interval);
            $("input[name='api_monitor[notify_emails]']").val(apiMonitor.notify_emails);

            $("input[name='api_monitor[enabled]']").prop("checked", apiMonitor.enabled);
        });
    }

    hourValid(hour) {
        return hour != "" && hour != "00:00:00";
    }

    getLastCheckedDay() {
        let day = "";
        if ($("input[name='api_monitor[monday]']").is(":checked") === true) {
            const startHour = $("input[name='api_monitor[monday_start]']").val();
            const endHour   = $("input[name='api_monitor[monday_end]']").val();

            if (this.hourValid(startHour) || this.hourValid(endHour)) {
                day = "monday";
            }
        }
        if ($("input[name='api_monitor[tuesday]']").is(":checked") === true) {
            const startHour = $("input[name='api_monitor[tuesday_start]']").val();
            const endHour   = $("input[name='api_monitor[tuesday_end]']").val();

            if (this.hourValid(startHour) || this.hourValid(endHour)) {
                day = "tuesday";
            }
        }
        if ($("input[name='api_monitor[wednesday]']").is(":checked") === true) {
            const startHour = $("input[name='api_monitor[wednesday_start]']").val();
            const endHour   = $("input[name='api_monitor[wednesday_end]']").val();

            if (this.hourValid(startHour) || this.hourValid(endHour)) {
                day = "wednesday";
            }
        }
        if ($("input[name='api_monitor[thursday]']").is(":checked") === true) {
            const startHour = $("input[name='api_monitor[thursday_start]']").val();
            const endHour   = $("input[name='api_monitor[thursday_end]']").val();

            if (this.hourValid(startHour) || this.hourValid(endHour)) {
                day = "thursday";
            }
        }
        if ($("input[name='api_monitor[friday]']").is(":checked") === true) {
            const startHour = $("input[name='api_monitor[friday_start]']").val();
            const endHour   = $("input[name='api_monitor[friday_end]']").val();

            if (this.hourValid(startHour) || this.hourValid(endHour)) {
                day = "friday";
            }
        }
        if ($("input[name='api_monitor[saturday]']").is(":checked") === true) {
            const startHour = $("input[name='api_monitor[saturday_start]']").val();
            const endHour   = $("input[name='api_monitor[saturday_end]']").val();

            if (this.hourValid(startHour) || this.hourValid(endHour)) {
                day = "saturday";
            }
        }
        if ($("input[name='api_monitor[sunday]']").is(":checked") === true) {
            const startHour = $("input[name='api_monitor[sunday_start]']").val();
            const endHour   = $("input[name='api_monitor[sunday_end]']").val();

            if (this.hourValid(startHour) || this.hourValid(endHour)) {
                day = "sunday";
            }
        }
        return day;
    }

    getLastValues() {
        const lastDay = this.getLastCheckedDay();

        let startHour = 0;
        let endHour = 0;

        console.log(lastDay);
        switch (lastDay) {
            case "monday":
                startHour = $("input[name='api_monitor[monday_start]']").val() as number;
                endHour   = $("input[name='api_monitor[monday_end]']").val() as number;
                break;
            case "tuesday":
                startHour = $("input[name='api_monitor[tuesday_start]']").val() as number;
                endHour   = $("input[name='api_monitor[tuesday_end]']").val() as number;
                break;
            case "wednesday":
                startHour = $("input[name='api_monitor[wednesday_start]']").val() as number;
                endHour   = $("input[name='api_monitor[wednesday_end]']").val() as number;
                break;
            case "thursday":
                startHour = $("input[name='api_monitor[thursday_start]']").val() as number;
                endHour   = $("input[name='api_monitor[thursday_end]']").val() as number;
                break;
            case "friday":
                startHour = $("input[name='api_monitor[friday_start]']").val() as number;
                endHour   = $("input[name='api_monitor[friday_end]']").val() as number;
                break;
            case "saturday":
                startHour = $("input[name='api_monitor[saturday_start]']").val() as number;
                endHour   = $("input[name='api_monitor[saturday_end]']").val() as number;
                break;
            case "sunday":
                startHour = $("input[name='api_monitor[sunday_start]']").val() as number;
                endHour   = $("input[name='api_monitor[sunday_end]']").val() as number;
                break;
        }
        return { startHour, endHour };
    }
}

export function LoadPage() {
    InitPage("api_monitor index", () => {
        const c = new ApiMonitor();
    });
}
